<template>
  <transition v-for="message of messages" name="bottom-up">
    <div
        class="flash-message alert"
        @mouseenter="hovered"
        @mouseleave="hide"
        v-if="visible"
        :class="'alert-' + message.type"
    >
      <span>{{ message.msg }}</span>
      <span @click="hide">
        <icon name="close" />
      </span>
    </div>
  </transition>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';

export default {
  name: 'FlashMessage',
  props: {
    id: String,
    time: {
      type: Number,
      default: 5000,
    },
    flash: Object
  },
  setup(props, { attrs }) {
    const messages = reactive([]);
    const visible = ref(false);
    const timer = ref(null);

    const show = (message, type) => {
      messages.push({ msg: message, type: type });
      if (!visible.value) {
        visible.value = true;
        timer.value = setTimeout(hide, props.time);
      }
    };

    const check = () => {
      if (messages.length > 0) {
        visible.value = true;
        timer.value = setTimeout(hide, props.time);
      }
    };

    const hide = () => {
      visible.value = false;
      timer.value = setTimeout(() => {
        messages.shift();
        check();
      }, 500);
    };

    const hovered = () => {
      clearTimeout(timer.value);
      visible.value = true;
    };

    onMounted(() => {
      Inertia.on('error', (errors) => {
        console.log('errors', errors);
        if (errors.detail && errors.detail.errors && errors.detail.errors.msg) {
          const error = errors.detail.errors.msg;
          show(error, 'danger');
        }
      });
    });

    watch(() => props.flash, (flash) => {
      if (flash) {
        if (flash.success) {
          show(flash.success, 'success');
        }
        if (flash.danger) {
          show(flash.danger, 'danger');
        }
        if (flash.message) {
          show(flash.message, 'info');
        }
        if (flash.warning) {
          show(flash.warning, 'warning');
        }
      }
    }, { immediate: true });

    return {
      messages,
      visible,
      show,
      hide,
      hovered,
    };
  },
};
</script>

<style lang="scss" scoped>
.flash-message {
  text-align: right;
  top: auto;
  left: auto;
  position: fixed;
  right: 0;
  bottom: 43px;
  pointer-events: all;
  z-index: 9999;
  transform: none;
  min-width: auto;

  & > span {
    vertical-align: middle;
    margin: 0 0.5em;
  }

  .icon {
    cursor: pointer;
    vertical-align: middle;
  }
}

.bottom-up-enter-active,
.bottom-up-leave-active {
  transition: all 0.5s ease;
}

.bottom-up-enter,
.bottom-up-leave-to {
  bottom: -100%;
}
</style>